// ======================================================================
// File Name       : question
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

// QUESTION LIST
export const QUESTION_LIST_SEARCH = 'QUESTION_LIST_SEARCH';

// IMPORTED FILE LIST
export const GET_IMPORTED_FILE_LIST = 'GET_IMPORTED_FILE_LIST';

// EXPORT QUESTION LIST
export const EXPORT_QUESTION_LIST = 'EXPORT_QUESTION_LIST';

// IMPORT QUESTION LIST
export const IMPORT_QUESTION_LIST = 'IMPORT_QUESTION_LIST';

// REGISTER NEW BIG QUESTION
export const REGISTER_NEW_BIG_QUESTION = 'REGISTER_NEW_BIG_QUESTION';

// REGISTER NEW SINGLE QUESTION
export const REGISTER_NEW_SINGLE_QUESTION = 'REGISTER_NEW_SINGLE_QUESTION';

// REGISTER NEW SINGLE QUESTION
export const QUESTION_ATTRIBUTE_LIST = 'QUESTION_ATTRIBUTE_LIST';

// QUESTION ATTRIBUTE PACKAGE REGISTER
export const QUESTION_ATTRIBUTE_PACKAGE_REGISTER = 'QUESTION_ATTRIBUTE_PACKAGE_REGISTER';
export const QUESTION_DETAIL = 'QUESTION_DETAIL';
export const QUESTION_UPDATE = 'QUESTION_UPDATE';
export const QUESTION_DELETE = 'QUESTION_DELETE';

export const CREATE_VALUE_ATTRIBUTE_ITEM = 'CREATE_VALUE_ATTRIBUTE_ITEM';

// Question attribute
export const GET_ATTRIBUTE_LIST = 'GET_ATTRIBUTE_LIST';
export const GET_ATTRIBUTE_LIST_DIALOG = 'GET_ATTRIBUTE_LIST_DIALOG';
